import React from 'react';
import {useNavigate} from 'react-router-dom';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import {logoSquare} from '../../assets';
import { ThemeToggle } from '../ThemeToggle';
import { registeredTrademark } from '../../helpers/strings';

const TopAppBar: React.FC = () => {
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <AppBar
            position='sticky'
            sx={{
                backgroundColor: 'background.navigation',
                width: '100%',
                maxHeight: { xs: 56, sm: 64 },
                boxShadow: 1
            }}
            aria-label="Main navigation bar"
        >
            <Toolbar
                sx={{
                    justifyContent: 'space-between',
                    minHeight: { xs: 56, sm: 64 },
                    px: { xs: 2, sm: 3 }
                }}
            >
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: { xs: 1, sm: 2 },
                    cursor: 'pointer'
                }}
                onClick={() => navigate('/')}
                >
                    <Box
                        component="img"
                        sx={{
                            width: { xs: 35, sm: 40, md: 50 },
                            height: { xs: 35, sm: 40, md: 50 },
                        }}
                        alt="Future Gen logo"
                        src={logoSquare}
                    />
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'baseline',
                        gap: 0.5
                    }}>
                        <Typography
                            component='h1'
                            sx={{
                                color: 'text.primary',
                                fontWeight: 900,
                                fontSize: { xs: 18, sm: 24, md: 28 },
                                lineHeight: 1
                            }}
                        >
                            {isMobile ? 'FG' : 'Future Gen'}
                        </Typography>
                        {!isMobile && (
                            <Typography sx={{
                                fontSize: { xs: 10, sm: 12, md: 14 },
                                fontWeight: 500,
                                color: 'text.primary'
                            }}>
                                {registeredTrademark}
                            </Typography>
                        )}
                    </Box>
                </Box>
                <ThemeToggle />
            </Toolbar>
        </AppBar>
    );
};

export default TopAppBar; 